import { render, staticRenderFns } from "./UnloadingPhoto.vue?vue&type=template&id=3b3c566e&"
import script from "./UnloadingPhoto.vue?vue&type=script&lang=js&"
export * from "./UnloadingPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports